
// src/components/songEdit/components/TagInput.tsx
import React, { useState } from 'react';
import { Tag } from 'lucide-react';
import { RemovableBadge } from '../inputs/RemovableBadge';

interface TagInputProps {
  tags: string[];
  onAddTag: (tag: string) => void;
  onRemoveTag: (index: number) => void;
}

export const TagInput: React.FC<TagInputProps> = ({ tags, onAddTag, onRemoveTag }) => {
  const [currentTag, setCurrentTag] = useState('');

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && currentTag.trim()) {
      onAddTag(currentTag.trim());
      setCurrentTag('');
    }
  };

  return (
    <div className="tags-input__container">
      <div className="input-group mb-2">
        <input
          type="text"
          className="song-form__input form-control"
          value={currentTag}
          onChange={(e) => setCurrentTag(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Press Enter to add tag"
        />
        <button className="btn btn-icon btn-secondary" type="button">
          <Tag size={20} />
        </button>
      </div>
      <div className="tags-input__list">
        {tags.map((tag, index) => (
          <RemovableBadge
            key={index}
            text={tag}
            onRemove={() => onRemoveTag(index)}
          />
        ))}
      </div>
    </div>
  );
};